var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationDarkblueRedDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification_darkblue_red_dot",
    transform: "translate(16206.5 8756.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7886",
    "data-name": "Rectangle 7886",
    width: 28,
    height: 28,
    transform: "translate(-16206.5 -8756.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135359",
    "data-name": "Group 135359",
    transform: "translate(-1.77 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M6548.382,13044.794v-4.874a6.922,6.922,0,1,0-13.843,0v4.874a2.692,2.692,0,0,0,1.153,5.124h2a3.845,3.845,0,0,0,7.537,0h2a2.692,2.692,0,0,0,1.153-5.124Zm-6.921,6.662a2.307,2.307,0,0,1-2.166-1.538h4.332A2.306,2.306,0,0,1,6541.46,13051.456Z",
    transform: "translate(-22735.461 -21783.998)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_135357",
    "data-name": "Group 135357",
    transform: "translate(-16578 -8857.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7259",
    "data-name": "Rectangle 7259",
    width: 10,
    height: 10,
    rx: 7,
    transform: "translate(385 101)",
    fill: "#f06363"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDarkblueRedDot);
export default __webpack_public_path__ + "static/media/Notification_darkblue_red_dot.69703746e36c99c5cc4082a8b3e2975d.svg";
export { ForwardRef as ReactComponent };